export default class HashManager {
    constructor(parent) {
        this.parent = parent;
        this.params = new URLSearchParams(window.location.hash?.substring(1));
    }

    update() {
        window.location.hash = this.params.toString();
    }

    get(key) {
        return this.params.get(key);
    }

    set(key, value) {
        if(value !== null && value !== undefined) {
            this.params.set(key, value);
        } else {
            this.remove(key);
        }     
    }

    has(key) {
        return this.params.has(key);
    }

    remove(key) {
        this.params.delete(key);
    }
}